"use strict";
const collectionFunctions = require('../../interfaces/orderAndInvoiceRows/collections');
const propertiesFunctions = require('../../interfaces/orderAndInvoiceRows/properties');
const alcTaxAdjustmentsFunctions = require('../../interfaces/orderAndInvoiceRows/alcTaxAdjustments');
// eslint-disable-next-line
const deliveryRules = require('./deliveryRules');
const trackingUrl = require('./trackingUrl');
const externalReferences = require('../../interfaces/externalReferences');
const constExtras = require('./const.extras');
const emcs = require('../../interfaces/transportOrder/emcs');
const createSearchStringQueryForCustomer = require('./create-search-string-query-for-customer');
// Since we only need the export from outside domainmodel it will work anyway since order-flow will then be a js file.
// eslint-disable-next-line
const orderFlow = require('./order-flow').default;
module.exports = {
    ...collectionFunctions,
    ...propertiesFunctions,
    ...trackingUrl,
    ...alcTaxAdjustmentsFunctions,
    ...externalReferences,
    ...constExtras,
    ...emcs,
    ...deliveryRules,
    createSearchStringQueryForCustomer,
    executeOrderFlowChecks: orderFlow,
};
